<!-- @format -->

<div class="info-container">
	<div class="info-header-container hmf-mb-xs">
		<homefield-icon
			[fill]="iconFillColor"
			[name]="content ? content[accessState]?.icon : ''"></homefield-icon>
		<span class="info-header hmf-ml-xxs">{{
			content ? (isAOS ? getAOSHeaderText() : getHeaderText()) : ''
		}}</span>
	</div>
	<div
		[ngClass]="isAOS ? 'aos-info-text-width' : 'info-text-width'"
		class="info-text">
		<span
			[innerHTML]="
				!content
					? ''
					: isAOS
						? content[accessState]?.aosBodyText
						: (content[accessState]?.bodyText | bypassSanitization)
			"></span>
	</div>
</div>
